var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside-brand d-flex flex-column align-items-center flex-column-auto py-5 py-lg-12"},[_c('a',{on:{"click":_vm.onLogoClicked}},[_c('img',{staticClass:"max-h-60px",attrs:{"src":_vm.siteLogo(),"alt":"Logo"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }